import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
const CheckinCard = ({ className, children, padding }) => {
    const { CheckinCard: theme } = useTheme('CheckinCard');
    return (React.createElement("div", { className: cn(theme.root, className), style: { padding } }, children));
};
export default CheckinCard;
